import React from "react";
import {
  BoltIcon,
  DocumentMagnifyingGlassIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline";

import FeatureGate from "./FeatureGate";

const AuditsIcon = () => (
  <svg
    viewBox="0 0 64 64"
    className="h-16 w-16 text-theme-primary"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="14"
      y="8"
      width="36"
      height="48"
      rx="5"
      stroke="currentColor"
      strokeWidth="2"
      className="opacity-80"
    />
    <path
      d="M24 22h16M24 30h16M24 38h10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className="opacity-60"
    />
    <circle
      cx="44"
      cy="44"
      r="10"
      className="fill-theme-main"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M39.5 44.5l3 3 6-7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="20"
      strokeDashoffset="20"
    >
      <animate
        attributeName="stroke-dashoffset"
        values="20;0;0;20"
        keyTimes="0;0.25;0.75;1"
        dur="4s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

const AuditsPaywall = () => (
  <FeatureGate
    icon={<AuditsIcon />}
    title="SEO and UX audits"
    description="Scan every page for SEO, UX, and speed issues, then turn findings into fixable suggestions for your site."
    featureLabel="Audits"
    bullets={[
      { icon: DocumentMagnifyingGlassIcon, text: "Page-level SEO and UX checks" },
      { icon: BoltIcon, text: "Performance and indexing signals" },
      { icon: WrenchScrewdriverIcon, text: "Suggestions you can send to Changes" },
    ]}
  />
);

export default AuditsPaywall;
